
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/user-interviews",
      function () {
        return require("private-next-pages/destinations/user-interviews.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/user-interviews"])
      });
    }
  